import { BoxStylingBase } from './BoxStylingBase'
import { BoxStylingSimpleCg } from './BoxStylingSimpleCg'

export const UNIT_PX = 'px'

export type BoxStyling = BoxStylingBase|BoxStylingSimpleCg
